export default __webpack_public_path__ + "static/media/BHPLoading.1e7bc68d.gif";